<!--Brand-->
<div class="brand flex-column-auto" id="kt_brand" [ngClass]="brandClasses">
    <!--begin::Logo-->
    <a routerLink="/" class="brand-logo">
        <img alt="Logo" class="img-fluid" [attr.src]="headerLogo"/>
    </a>
    <!--end::Logo-->

    <!--    <ng-container *ngIf="asideSelfMinimizeToggle">-->
    <!--        <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">-->
    <!--      <span [inlineSVG]=" './assets/media/svg/icons/Navigation/Angle-double-left.svg'" cacheSVG="true"-->
    <!--            class="svg-icon svg-icon-xl">-->
    <!--      </span>-->
    <!--        </button>-->
    <!--    </ng-container>-->
</div>

<!--Aside Menu-->
<div  class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
    <ng-container  *ngIf="disableAsideSelfDisplay">
        <!--Header Logo-->
        <a routerLink="/">
            <img alt="Logo" [attr.src]="headerLogo"/>
        </a>
        <!--Header Logo-->
    </ng-container>
    <!--Menu Container-->
    <div id="kt_aside_menu" class="aside-menu" [ngClass]="asideMenuCSSClasses" data-menu-vertical="1"
         [attr.data-menu-scroll]="asideMenuScroll" [attr.data-menu-dropdown]="asideMenuDropdown"
         data-menu-dropdown-timeout="500">

        <!-- Menu Nav -->
        <ul  class="menu-nav" [ngClass]="ulCSSClasses">

            <!-- Client -->
            <li class="menu-section"
                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_client','ROLE_TicketsView', 'ROLE_TicketsFull', 'ROLE_demo_user']">
                <h4 class="menu-text">Client</h4>
                <i class="menu-icon flaticon-more-v2"></i>
            </li>

            <!-- Tickets -->
            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                routerLinkActive="menu-item-open"
                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_client','ROLE_TicketsView', 'ROLE_TicketsFull', 'ROLE_demo_user']"
            >
                <a class="menu-link menu-toggle" routerLink='/tickets/list' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/Communication/Group-chat.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Tickete</span>
                </a>
            </li>

<!--            &lt;!&ndash; CRM &ndash;&gt;-->
<!--            <li class="menu-section"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_ProductsView', 'ROLE_ProductsFull', 'ROLE_ContactsView', 'ROLE_ContactsFull','ROLE_OffersView', 'ROLE_OffersFull', 'ROLE_ContractsView', 'ROLE_ContractsFull', 'ROLE_CRMReportsView', 'ROLE_CRMReportsFull', 'ROLE_demo_user']">-->
<!--                <h4 class="menu-text">CRM</h4>-->
<!--                <i class="menu-icon flaticon-more-v2"></i>-->
<!--            </li>-->

<!--            &lt;!&ndash; Produse &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_ProductsView', 'ROLE_ProductsFull', 'ROLE_demo_user']"-->
<!--            >-->
<!--                <a class="menu-link menu-toggle" routerLink="/products/list" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Cart3.svg'"-->
<!--                          cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"-->
<!--                    ></span>-->
<!--                    <span class="menu-text" translate="MENU.PRODUCTS"></span>-->
<!--                </a>-->
<!--            </li>-->

<!--            &lt;!&ndash; Contacte &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ContactsView', 'ROLE_ContactsFull', 'ROLE_demo_user']"-->
<!--            >-->
<!--                <a class="menu-link menu-toggle" routerLink="/contacts/list" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.CONTACTS"></span>-->
<!--                </a>-->
<!--            </li>-->

<!--            &lt;!&ndash; Oferte &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_OffersView', 'ROLE_OffersFull', 'ROLE_demo_user']"-->
<!--            >-->
<!--                <a class="menu-link menu-toggle" routerLink="/offers/list" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Files/Compiled-file.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.OFFERS"></span>-->
<!--                </a>-->
<!--            </li>-->

            <!-- Contract -->
            <!--            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"-->
            <!--                routerLinkActive="menu-item-open"-->
            <!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_ContractsFull', 'ROLE_ContractsView']">-->
            <!--                <a class="menu-link menu-toggle" href="#" routerLinkActive="active">-->
            <!--                    <span [inlineSVG]="'./assets/media/svg/icons/Files/Folder.svg'" cacheSVG="true"-->
            <!--                          class="svg-icon menu-icon"></span>-->
            <!--                    <span class="menu-text" translate="MENU.CONTRACTS"></span>-->
            <!--                    <i class="menu-arrow"></i>-->
            <!--                </a>-->
            <!--                <div class="menu-submenu">-->
            <!--                    <i class="menu-arrow"></i>-->
            <!--                    <ul class="menu-subnav">-->
            <!--                        <li class="menu-item menu-item-parent" aria-haspopup="true">-->
            <!--              <span class="menu-link">-->
            <!--                <span class="menu-text" translate="MENU.CONTRACTS"></span>-->
            <!--              </span>-->
            <!--                        </li>-->
            <!--                        &lt;!&ndash; Adauga Contract &ndash;&gt;-->
            <!--                        <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active">-->
            <!--                            <a class="menu-link" routerLink="/contracts/add" routerLinkActive="active">-->
            <!--                                <span [inlineSVG]="'./assets/media/svg/icons/Files/Folder-plus.svg'" cacheSVG="true"-->
            <!--                                      class="svg-icon menu-icon"></span>-->
            <!--                                <span class="menu-text" translate="MENU.ADD_CONTRACT"></span>-->
            <!--                            </a>-->
            <!--                        </li>-->
            <!--                        &lt;!&ndash; Lista Contracte &ndash;&gt;-->
            <!--                        <li class="menu-item"-->
            <!--                            aria-haspopup="true"-->
            <!--                            routerLinkActive="menu-item-active">-->
            <!--                            <a class="menu-link"-->
            <!--                               routerLink="/contracts/list"-->
            <!--                               routerLinkActive="active">-->
            <!--                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"-->
            <!--                                      class="svg-icon menu-icon"></span>-->
            <!--                                <span class="menu-text" translate="MENU.LIST_CONTRACTS"></span>-->
            <!--                            </a>-->
            <!--                        </li>-->
            <!--                    </ul>-->
            <!--                </div>-->
            <!--            </li>-->

<!--            &lt;!&ndash;Reports&ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_CRMReportsView', 'ROLE_CRMReportsFull', 'ROLE_demo_user']">-->
<!--                <a class="menu-link menu-toggle" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Chart-bar1.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.REPORTS"></span>-->
<!--                    <i class="menu-arrow"></i>-->
<!--                </a>-->
<!--                <div class="menu-submenu">-->
<!--                    <i class="menu-arrow"></i>-->
<!--                    <ul class="menu-subnav">-->
<!--                        &lt;!&ndash; Tickets Reports &ndash;&gt;-->
<!--                        <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active">-->
<!--                            <a class="menu-link" routerLink="reports-crm/tickets" routerLinkActive="active">-->
<!--                              <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Chart-pie.svg'"-->
<!--                                    cacheSVG="true"-->
<!--                                    class="svg-icon menu-icon"-->
<!--                              ></span>-->
<!--                                <span class="menu-text" translate="MENU.TICKETS"></span>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </li>-->

<!--            &lt;!&ndash; ERP &ndash;&gt;-->
<!--            <li class="menu-section"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_ProjectsView', 'ROLE_ProjectsFull', 'ROLE_ERPTasksView', 'ROLE_ERPTasksFull', 'ROLE_DirectivesView', 'ROLE_DirectivesFull', 'ROLE_ProceduresView', 'ROLE_ProceduresFull', 'ROLE_ERPReportsView', 'ROLE_ERPReportsFull', 'ROLE_demo_user']">-->
<!--                <h4 class="menu-text">ERP</h4>-->
<!--                <i class="menu-icon flaticon-more-v2"></i>-->
<!--            </li>-->

<!--            &lt;!&ndash; Proiecte &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin','ROLE_ProjectsView', 'ROLE_ProjectsFull', 'ROLE_demo_user']"-->
<!--            >-->
<!--                <a class="menu-link menu-toggle" routerLink="/projects/list" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Files/Selected-file.svg'"-->
<!--                          cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"-->
<!--                    ></span>-->
<!--                    <span class="menu-text" translate="MENU.PROJECTS"></span>-->
<!--                </a>-->
<!--            </li>-->

<!--            &lt;!&ndash; Tasks &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ERPTasksView', 'ROLE_ERPTasksFull', 'ROLE_demo_user']">-->
<!--                <a class="menu-link menu-toggle" routerLink="/tasks" routerLinkActive="active">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/General/Clipboard.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.TASKS"></span>-->
<!--                </a>-->
<!--            </li>-->

<!--            &lt;!&ndash; Directive &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_DirectivesView', 'ROLE_DirectivesFull', 'ROLE_demo_user']">-->
<!--                <a class="menu-link menu-toggle" routerLink="directives/list">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/General/Bookmark.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.DIRECTIVES"></span>-->
<!--                </a>-->
<!--            </li>-->

<!--            &lt;!&ndash; Procedures :: Start &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProceduresView', 'ROLE_ProceduresFull', 'ROLE_demo_user']">-->
<!--                <a class="menu-link menu-toggle" routerLink="procedures/list">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/General/Settings-2.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.PROCEDURES"></span>-->
<!--                </a>-->

<!--            </li>-->
<!--            &lt;!&ndash; Procedures :: End &ndash;&gt;-->

<!--            &lt;!&ndash; Feedback :: Start &ndash;&gt;-->
<!--            <li class="menu-item menu-item-submenu"-->
<!--                aria-haspopup="true"-->
<!--                data-menu-toggle="hover"-->
<!--                routerLinkActive="menu-item-open"-->
<!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_demo_user']">-->

<!--                <a class="menu-link menu-toggle" routerLink="feedback/list">-->
<!--                    <span [inlineSVG]="'./assets/media/svg/icons/Communication/Chat1.svg'" cacheSVG="true"-->
<!--                          class="svg-icon menu-icon"></span>-->
<!--                    <span class="menu-text" translate="MENU.FEEDBACK"></span>-->
<!--&lt;!&ndash;                    <i class="menu-arrow"></i>&ndash;&gt;-->
<!--                </a>-->
<!--&lt;!&ndash;                <div class="menu-submenu">&ndash;&gt;-->
<!--&lt;!&ndash;                    <i class="menu-arrow"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                    <ul class="menu-subnav">&ndash;&gt;-->

<!--&lt;!&ndash;                        &lt;!&ndash; Feedback Label :: Start &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        <li class="menu-item menu-item-parent" aria-haspopup="true">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span class="menu-link"><span class="menu-text" translate="MENU.FEEDBACK"></span></span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash; Feedback Label :: End &ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;                        &lt;!&ndash; Feedback List :: Start &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        <li class="menu-item" aria-haspopup="true" routerLinkActive="menu-item-active">&ndash;&gt;-->
<!--&lt;!&ndash;                            <a class="menu-link" routerLink="/feedback/list" routerLinkActive="active">&ndash;&gt;-->
<!--&lt;!&ndash;                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"&ndash;&gt;-->
<!--&lt;!&ndash;                                      class="svg-icon menu-icon"></span>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="menu-text" translate="MENU.LIST_FEEDBACK"></span>&ndash;&gt;-->
<!--&lt;!&ndash;                            </a>&ndash;&gt;-->
<!--&lt;!&ndash;                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash; Feedback List :: End &ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;                    </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--            </li>-->
<!--            &lt;!&ndash; Feedback :: End &ndash;&gt;-->

            <!--Reports ERP-->
            <!--            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"-->
            <!--                routerLinkActive="menu-item-open"-->
            <!--                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin']">-->
            <!--                <a class="menu-link menu-toggle" href="#" routerLinkActive="active" routerLink='/reports-erp'>-->
            <!--                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Chart-bar1.svg'" cacheSVG="true"-->
            <!--                          class="svg-icon menu-icon"></span>-->
            <!--                    <span class='menu-text'>Reports</span>-->
            <!--                    <i class="menu-arrow"></i>-->
            <!--                </a>-->
            <!--                <div class="menu-submenu">-->
            <!--                    <i class="menu-arrow"></i>-->
            <!--                    <ul class="menu-subnav">-->
            <!--                        <li class="menu-item menu-item-parent" aria-haspopup="true">-->
            <!--                            <span class="menu-link"><span class="menu-text" translate="MENU.CONTRACTS"></span></span>-->
            <!--                        </li>-->
            <!--                    </ul>-->
            <!--                </div>-->
            <!--            </li>-->

            <!-- HR -->
            <li class="menu-section"
                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_WorkTrackerFull', 'ROLE_LeaveRequestFull', 'ROLE_demo_user']">
                <h4  class="menu-text">HR</h4>
                <i class="menu-icon flaticon-more-v2"></i>
            </li>

            <!-- Users -->
            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"
                routerLinkActive="menu-item-open"
                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_WorkTrackerFull', 'ROLE_LeaveRequestFull','ROLE_demo_user']">
                <a class="menu-link menu-toggle" href="/material" routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/Files/User-folder.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Utilizatorii mei</span>
                    <i class="menu-arrow"></i>
                </a>
                <div class="menu-submenu">
                    <i class="menu-arrow"></i>
                    <ul class="menu-subnav">
                        <li class="menu-item menu-item-parent" aria-haspopup="true">
                            <span class="menu-link"><span class="menu-text" translate="MENU.USERS"></span></span>
                        </li>

                        <!-- Staff -->
                        <li class="menu-item"
                            aria-haspopup="true"
                            *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_WorkTrackerFull', 'ROLE_LeaveRequestFull', 'ROLE_demo_user']"
                            routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="users/list" routerLinkActive="active">
                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                      class="svg-icon menu-icon"></span>
                                <span class="menu-text">My Team</span>
                            </a>
                        </li>

                        <!-- Clients -->
                        <li class="menu-item"
                            aria-haspopup="true"
                            *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_demo_user']"
                            routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="users/list-clients" routerLinkActive="active">
                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                      class="svg-icon menu-icon"></span>
                                <span class="menu-text">My Clients</span>
                            </a>
                        </li>

                        <!--My Team Holidays Requests-->
                        <li class="menu-item"
                            aria-haspopup="true"
                            routerLinkActive="menu-item-active"
                            *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_LeaveRequestFull', 'ROLE_demo_user']">
                            <a class="menu-link" routerLink="users/holiday-requests" routerLinkActive="active">
                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                      class="svg-icon menu-icon"></span>
                                <span class="menu-text">Holiday Requests</span>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>

            <!-- Admin -->
            <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover"
                routerLinkActive="menu-item-open" *ngIf="userRolesList | roleChecker : ['ROLE_super_admin']">
                <a class="menu-link menu-toggle" routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/General/User.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text" translate="MENU.ADMIN"></span>
                    <i class="menu-arrow"></i>
                </a>
                <div class="menu-submenu">
                    <i class="menu-arrow"></i>
                    <ul class="menu-subnav">
                        <li class="menu-item menu-item-parent" aria-haspopup="true">
                            <span class="menu-link"><span
                                    class="menu-text" translate="MENU.MY_PROFILE"></span>
                            </span>
                        </li>
                        <!--List All Users-->
                        <li class="menu-item" aria-haspopup="true"
                            routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="users/list-all" routerLinkActive="active">
                                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                          class="svg-icon menu-icon"></span>
                                <span class="menu-text">All Users</span>
                            </a>
                        </li>

                        <!--List All Clients-->
                        <li class="menu-item" aria-haspopup="true"
                            routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="users/list-all-clients" routerLinkActive="active">
                                    <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                          class="svg-icon menu-icon"></span>
                                <span class="menu-text">All Clients</span>
                            </a>
                        </li>

                        <!--All Holidays Requests-->
                        <li class="menu-item" aria-haspopup="true"
                            routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="users/all-holiday-requests" routerLinkActive="active">
                                <span [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'" cacheSVG="true"
                                      class="svg-icon menu-icon"></span>
                                <span class="menu-text">All Holidays Requests</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>


            <!-- User Control-->
            <li class="menu-section"
                *ngIf="!(userRolesList | roleChecker : ['ROLE_client'])">
                <h4 class="menu-text">Management User</h4>
                <i class="menu-icon flaticon-more-v2"></i>
            </li>

            <!-- Edit Profile -->
            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                *ngIf="!(userRolesList | roleChecker : ['ROLE_client', 'ROLE_demo_user'])"
                routerLinkActive="menu-item-open">
                <a class="menu-link menu-toggle" routerLink='/user-profile/edit' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/General/Edit.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Editare profil</span>
                </a>
            </li>

            <!-- Working Schedule -->
            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                routerLinkActive="menu-item-open"
                *ngIf="!(userRolesList | roleChecker : ['ROLE_client'])">
                <a class="menu-link menu-toggle" routerLink='/work-tracker/my-list' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/Home/Alarm-clock.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Program de lucru</span>
                </a>
            </li>

            <!-- My Holidays Requests -->
            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                routerLinkActive="menu-item-open"
                *ngIf="!(userRolesList | roleChecker : ['ROLE_client'])">
                <a class="menu-link menu-toggle" routerLink='/days-off/list' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/General/Smile.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Cereri concediu</span>
                </a>
            </li>

            <!-- User Settings -->
            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                routerLinkActive="menu-item-open"
                *ngIf="userRolesList | roleChecker : ['ROLE_super_admin', 'ROLE_admin']">
                <a class="menu-link menu-toggle" routerLink='/user-settings/holidays' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/General/Settings-2.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Setări</span>
                </a>
            </li>

            <!-- About Us -->

            <li class="menu-section">
                <h4 class="menu-text">Grafinia Design</h4>
                <i class="menu-icon flaticon-more-v2"></i>
            </li>

            <li class="menu-item menu-item-submenu"
                aria-haspopup="true"
                data-menu-toggle="hover"
                routerLinkActive="menu-item-open">
                <a class="menu-link menu-toggle" routerLink='/about-us' routerLinkActive="active">
                    <span [inlineSVG]="'./assets/media/svg/icons/Home/Book-open.svg'" cacheSVG="true"
                          class="svg-icon menu-icon"></span>
                    <span class="menu-text">Despre noi</span>
                </a>
            </li>

        </ul>

    </div>
</div>
<div class="text-dark floating-btn">
    <app-accessibility></app-accessibility>
</div>
